export default "__VITE_ASSET__DL0e8QoM__"